import { render, staticRenderFns } from "./AxPanel.vue?vue&type=template&id=1d169d30&scoped=true&"
import script from "./AxPanel.vue?vue&type=script&lang=ts&"
export * from "./AxPanel.vue?vue&type=script&lang=ts&"
import style0 from "./AxPanel.vue?vue&type=style&index=0&id=1d169d30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d169d30",
  null
  
)

export default component.exports